"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsInput = exports.UsSelectStyleEnum = exports.UsSelectValueStyleEnum = exports.UsInputTypeEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const UsInput_style_1 = require("./UsInput.style");
const UsHelpButton_1 = require("../UsHelpButton/UsHelpButton");
var UsInputTypeEnum;
(function (UsInputTypeEnum) {
    UsInputTypeEnum["TEXT"] = "text";
    UsInputTypeEnum["PASSWORD"] = "password";
    UsInputTypeEnum["EMAIL"] = "email";
    UsInputTypeEnum["NUMBER"] = "number";
})(UsInputTypeEnum = exports.UsInputTypeEnum || (exports.UsInputTypeEnum = {}));
var UsSelectValueStyleEnum;
(function (UsSelectValueStyleEnum) {
    UsSelectValueStyleEnum["DEFAULT"] = "";
    UsSelectValueStyleEnum["LABEL_FORM"] = "label-form";
})(UsSelectValueStyleEnum = exports.UsSelectValueStyleEnum || (exports.UsSelectValueStyleEnum = {}));
var UsSelectStyleEnum;
(function (UsSelectStyleEnum) {
    UsSelectStyleEnum["DEFAULT"] = "";
    UsSelectStyleEnum["NO_BORDER"] = "no-border";
    UsSelectStyleEnum["NO_BORDER_UNDERLINED"] = "no-border underlined";
    UsSelectStyleEnum["NO_BORDER_UNDERLINED_CENTERED"] = "no-border underlined centered";
})(UsSelectStyleEnum = exports.UsSelectStyleEnum || (exports.UsSelectStyleEnum = {}));
const eyeHiddenSrc = '/TpdPortalCommons/build/assets/ico_hidePassword.png';
const eyeOpenSrc = '/TpdPortalCommons/build/assets/ico_showPassword.png';
const UsInput = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const isTypePassword = (0, react_1.useMemo)(() => props.type === UsInputTypeEnum.PASSWORD, [props.type]);
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    const [isOnFocus, setIsOnFocus] = react_1.default.useState(false);
    // const isInvalid = useMemo<boolean>(() => !!props.fieldError, [props.fieldError]);
    const handlerClick = (e) => {
        if (!props.disabled)
            props.onClick && props.onClick();
    };
    const handlerFocus = (e) => {
        if (!props.disabled) {
            setIsOnFocus(true);
            props.onFocus && props.onFocus();
        }
    };
    const handlerBlur = (e) => {
        setIsOnFocus(false);
        props.onBlur && props.onBlur();
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return ((0, jsx_runtime_1.jsx)(UsInput_style_1.UsInputContainer, Object.assign({ className: `us-input ${props.className}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `us-input-container`, "data-testid": "us-input-container" }, { children: [props.config.label && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "us-input-label" }, { children: (0, jsx_runtime_1.jsxs)("label", Object.assign({ htmlFor: props.config.name }, { children: [((_a = props.config.rules) === null || _a === void 0 ? void 0 : _a.required) && ((0, jsx_runtime_1.jsx)("span", { children: " * " })), props.config.label, props.config.tooltip && ((0, jsx_runtime_1.jsx)(UsHelpButton_1.UsHelpButton, { title: props.config.label, content: props.config.tooltip, type: (_b = props.config.tooltipType) !== null && _b !== void 0 ? _b : UsHelpButton_1.UsHelpButtonType.default }))] })) }))), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "us-input-wrapper", style: { backgroundColor: (_c = props.config.backgroundColor) !== null && _c !== void 0 ? _c : 'transparent' } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "us-input-real" }, { children: [(0, jsx_runtime_1.jsx)("input", { "data-testid": "us-input", name: props.name, value: props.value, onChange: props.onChange, disabled: props.disabled, minLength: props.minLength, maxLength: props.maxLength, id: props.config.name, type: props.type === UsInputTypeEnum.PASSWORD ?
                                    (showPassword ? UsInputTypeEnum.TEXT : UsInputTypeEnum.PASSWORD) : props.type, required: props.required, placeholder: isOnFocus ? (_d = props.onFocusPlaceholder) !== null && _d !== void 0 ? _d : props.placeholder : props.placeholder, readOnly: props.readOnly, onClick: handlerClick, onFocus: handlerFocus, onBlur: handlerBlur, unbluCapturingHint: props.unbluHintBlock ? 'block' : null, className: `
                                            ${props.invalid ? 'us-input-wrapper-errors' : ''}
                                            ${((_e = props.config.rules) === null || _e === void 0 ? void 0 : _e.required) && !props.invalid ? 'us-input-wrapper-valid' : ''}
                                            ${props.disabled ? 'us-input-disabled' : ''}
                                        ` }), props.charToPinEnd && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "us-currency" }, { children: props.charToPinEnd }))), isTypePassword && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { "data-testid": "us-input-type-password", src: showPassword ? eyeOpenSrc : eyeHiddenSrc, className: "us-occhietto-pwd", onClick: togglePasswordVisibility }) }))] })) })), !props.hideErrorsInline && props.invalid && props.error && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `us-input-errors-wrapper active` }, { children: (0, jsx_runtime_1.jsx)("span", { children: (_f = props.error) === null || _f === void 0 ? void 0 : _f.message }) })))] })) })));
};
exports.UsInput = UsInput;
exports.UsInput.defaultProps = {
    unbluHintBlock: false,
    type: UsInputTypeEnum.TEXT,
    required: false,
    disabled: false,
    readOnly: false,
    placeholder: '',
    className: '',
};
